import * as React from 'react';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { TFunction } from 'i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@ooh/ui/components/card';
import { FormField } from '@ooh/ui/components/form-field';
import { Textarea } from '@ooh/ui/components/textarea';
import type { FormValues } from '../../../../lib/media-unit-form-schema';

interface NotesSectionProps {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  t: TFunction<'inventory'>;
}

export function NotesSection({ register, t }: NotesSectionProps) {
  return (
    <Card data-testid="section-notes">
      <CardHeader className="pb-4">
        <CardTitle className="text-[15px]">{t('form.sections.notes')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField label={t('form.fields.notes')} testId="field-notes">
          <Textarea
            placeholder={t('form.placeholders.notes')}
            rows={4}
            data-testid="textarea-notes"
            {...register('notes')}
          />
        </FormField>
        <FormField label={t('form.fields.wfContactPerson')} testId="field-wfContactPerson">
          <Textarea
            placeholder={t('form.placeholders.wfContactPerson')}
            rows={2}
            data-testid="textarea-wf-contact-person"
            {...register('wfContactPerson')}
          />
        </FormField>
        <FormField label={t('form.fields.locationDescription')} testId="field-locationDescription">
          <Textarea
            placeholder={t('form.placeholders.locationDescription')}
            rows={4}
            data-testid="textarea-location-description"
            {...register('locationDescription')}
          />
        </FormField>
      </CardContent>
    </Card>
  );
}
